/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/account-profile';

type PropsFromCaller = {
  isOpen: boolean;
  onClose: () => void;
};

type PropsToComponent = PropsFromCaller;

export const SkillsScoreInfoDialog = ({ isOpen, onClose }: PropsToComponent) => {
  return (
    <Dialog data-testid="projects-info-dialog" open={isOpen} onClose={onClose}>
      <Dialog.HeadingGroup>{_t('Projects')}</Dialog.HeadingGroup>
      <Dialog.Content>
        <TrackedDiv
          trackClicks={false}
          requireFullyVisible={false}
          withVisibilityTracking
          // not tracked in eventing v3
          trackingName="projects_info_dialog"
        >
          <Typography2 component="p">
            {_t(
              'These are used to demonstrate skills by working autonomously through realistic, job-related challenges and leveraging industry tools to create a unique solution. They’re a strong indicator of technical expertise, independent problem-solving, critical thinking, and communication skills.'
            )}
          </Typography2>
        </TrackedDiv>
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          component={TrackedButton}
          requireFullyVisible={false}
          withVisibilityTracking
          // not tracked in eventing v3
          trackingName="profile_close_projects_dialog"
          onClick={onClose}
        >
          {_t('Got it')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default SkillsScoreInfoDialog;
